import { CheckCircleIcon } from "@heroicons/react/20/solid";

export default function SuccessMessageStatus(props: {
  message: string;
  title?: string;
  className?: string;
}) {
  const { message, title, className } = props;
  return (
    <div
      className={`flex w-full gap-2 text-base ${className} ${title ? "flex-col md:flex-row md:items-center" : "items-center"}`}
    >
      <div className={`flex items-center gap-4`}>
        <CheckCircleIcon className="size-8 fill-green" />
        {title && <>{title}!</>}
      </div>
      <p className={`font-bold`}>{message}</p>
    </div>
  );
}
